"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePreferredPrintingService = void 0;
const react_1 = require("react");
const __1 = require("../../..");
const useLiveLocalStorage_1 = __importDefault(require("../../../lib/hooks/useLiveLocalStorage"));
const PrintServiceIds_1 = require("../PrintServiceIds");
const PrintServices_1 = require("../PrintServices");
function usePreferredPrintingService(outputType) {
    const { primaryPrintServiceId } = (0, __1.useMapmakerAppConfig)();
    const [preferredPrintingServiceId, _setPreferredPrintingServiceId,] = (0, useLiveLocalStorage_1.default)("mapmaker.preferredPrintingServiceId");
    const [preferredPrintingServiceIdForOutputType, _setPreferredPrintingServiceIdForOutputType,] = (0, useLiveLocalStorage_1.default)(`mapmaker.preferredPrintingServiceId.${outputType}`);
    // If this output type has a preference use that, otherwise use the global preference.
    const preferredPrintingService = getFirstAvailableService(outputType, [
        preferredPrintingServiceIdForOutputType,
        preferredPrintingServiceId,
        primaryPrintServiceId,
    ]);
    const setPreferredPrintingServiceId = (0, react_1.useCallback)((id) => {
        if (id === preferredPrintingServiceId) {
            return;
        }
        _setPreferredPrintingServiceId(id);
        _setPreferredPrintingServiceIdForOutputType(id);
        /*
        This is triggering way more than it should.
        trackGtmEvent({
          event: "mapmaker.set-preferred-printing-service",
          service: id,
        });
        */
    }, [
        preferredPrintingServiceId,
        _setPreferredPrintingServiceId,
        _setPreferredPrintingServiceIdForOutputType,
    ]);
    return [preferredPrintingService, setPreferredPrintingServiceId];
}
exports.usePreferredPrintingService = usePreferredPrintingService;
/*
 * Given an output type and a list of preferences (most preferred first) return the first preferred
 * one that is available.
 */
function getFirstAvailableService(outputType, ids) {
    if (!outputType) {
        return (0, PrintServices_1.getPrintingService)(PrintServiceIds_1.MapmakerPrintServiceId.DOWNLOAD);
    }
    const availableServiceIds = (0, PrintServices_1.getPrintServiceIdsForOutputType)(outputType);
    for (var id of ids) {
        if (id && availableServiceIds.includes(id)) {
            return (0, PrintServices_1.getPrintingService)(id);
        }
    }
    return (0, PrintServices_1.getPrintingService)(availableServiceIds[0]);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlUHJlZmVycmVkUHJpbnRpbmdTZXJ2aWNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvcHJpbnRpbmcvc2hhcmVkL3VzZVByZWZlcnJlZFByaW50aW5nU2VydmljZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxpQ0FBb0M7QUFDcEMsZ0NBQWdEO0FBR2hELGlHQUF5RTtBQUN6RSx3REFBNEQ7QUFDNUQsb0RBSTBCO0FBRTFCLFNBQWdCLDJCQUEyQixDQUN6QyxVQUE2QjtJQUU3QixNQUFNLEVBQUUscUJBQXFCLEVBQUUsR0FBRyxJQUFBLHdCQUFvQixHQUFFLENBQUM7SUFFekQsTUFBTSxDQUNKLDBCQUEwQixFQUMxQiw4QkFBOEIsRUFDL0IsR0FBRyxJQUFBLDZCQUFtQixFQUNyQixxQ0FBcUMsQ0FDdEMsQ0FBQztJQUNGLE1BQU0sQ0FDSix1Q0FBdUMsRUFDdkMsMkNBQTJDLEVBQzVDLEdBQUcsSUFBQSw2QkFBbUIsRUFDckIsdUNBQXVDLFVBQVUsRUFBRSxDQUNwRCxDQUFDO0lBRUYsc0ZBQXNGO0lBQ3RGLE1BQU0sd0JBQXdCLEdBQUcsd0JBQXdCLENBQUMsVUFBVSxFQUFFO1FBQ3BFLHVDQUF1QztRQUN2QywwQkFBMEI7UUFDMUIscUJBQXFCO0tBQ3RCLENBQUMsQ0FBQztJQUVILE1BQU0sNkJBQTZCLEdBQUcsSUFBQSxtQkFBVyxFQUMvQyxDQUFDLEVBQTBCLEVBQUUsRUFBRTtRQUM3QixJQUFJLEVBQUUsS0FBSywwQkFBMEIsRUFBRTtZQUNyQyxPQUFPO1NBQ1I7UUFDRCw4QkFBOEIsQ0FBQyxFQUFFLENBQUMsQ0FBQztRQUNuQywyQ0FBMkMsQ0FBQyxFQUFFLENBQUMsQ0FBQztRQUNoRDs7Ozs7O1VBTUU7SUFDSixDQUFDLEVBQ0Q7UUFDRSwwQkFBMEI7UUFDMUIsOEJBQThCO1FBQzlCLDJDQUEyQztLQUM1QyxDQUNGLENBQUM7SUFFRixPQUFPLENBQUMsd0JBQXdCLEVBQUUsNkJBQTZCLENBQUMsQ0FBQztBQUNuRSxDQUFDO0FBaERELGtFQWdEQztBQUVEOzs7R0FHRztBQUNILFNBQVMsd0JBQXdCLENBQy9CLFVBQTZCLEVBQzdCLEdBQTJDO0lBRTNDLElBQUksQ0FBQyxVQUFVLEVBQUU7UUFDZixPQUFPLElBQUEsa0NBQWtCLEVBQUMsd0NBQXNCLENBQUMsUUFBUSxDQUFDLENBQUM7S0FDNUQ7SUFDRCxNQUFNLG1CQUFtQixHQUFHLElBQUEsK0NBQStCLEVBQUMsVUFBVSxDQUFDLENBQUM7SUFDeEUsS0FBSyxJQUFJLEVBQUUsSUFBSSxHQUFHLEVBQUU7UUFDbEIsSUFBSSxFQUFFLElBQUksbUJBQW1CLENBQUMsUUFBUSxDQUFDLEVBQUUsQ0FBQyxFQUFFO1lBQzFDLE9BQU8sSUFBQSxrQ0FBa0IsRUFBQyxFQUFFLENBQUMsQ0FBQztTQUMvQjtLQUNGO0lBQ0QsT0FBTyxJQUFBLGtDQUFrQixFQUFDLG1CQUFtQixDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7QUFDcEQsQ0FBQyJ9